import script from "./login.vue?vue&type=script&lang=ts&setup=true"
export * from "./login.vue?vue&type=script&lang=ts&setup=true"

import "./login.vue?vue&type=style&index=0&id=42872f6c&lang=css"

const __exports__ = script;

export default __exports__